import script from "./MandalaController.vue?vue&type=script&setup=true&lang=js"
export * from "./MandalaController.vue?vue&type=script&setup=true&lang=js"

import "./MandalaController.vue?vue&type=style&index=0&id=8f8fa1bc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f8fa1bc"]])

export default __exports__